import React, { useMemo, useEffect } from 'react';
import classnames from "classnames";
import { FromHead } from "ellow-web-ui-components-library";
import Field from '../../../../components/field/freeField';
import Headline4 from "../../../../components/headings/Headline4";
import Button from '../../../../components/button'
import RadioButton from '../../../../components/radio';
import Datepicker from '../../../../components/datepicker';
import Styles from "../../../dashBoard/styles.module.scss";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RadioGroup from '../../../../components/radioGroup';
import * as CONSTANTS from '../../../../utils/CONSTANTS'
import * as Utils from '../../../../utils/EllowUtils'
import { useState } from 'react';
import { Error } from "@progress/kendo-react-labels";
import mixpanelData from '../../../../utils/mixpanel';

const profileMetadata = localStorage.getItem("profile_metadata") === null ? console.log('true') : JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
export type AvailabilityFormFields = {
  workType: number;
  availabilityId: number;
  date: any;
  jobSearchCriteria:any;
  contractType: number;
  weeks: string | null;
};

interface Props {
  OnSubmit: any,
  loginId?: string | null,
  defaultValues: { availability: {availabilityId: number | undefined, date: string}, contractType: number | undefined, workType: number | undefined, jobSearchCriteria: number | undefined},
}


// const BasicDetails: React.FC<{handleSubmit: () => void}> = (props) => {
const Avilability: React.FC<Props> = ({
  OnSubmit,
  defaultValues,
  loginId
}) => {  

  const validationSchema = Yup.object({

  });

  const formOptions = { resolver: yupResolver(validationSchema), defaultValues: useMemo(() => {
    return defaultValues;
  }, [defaultValues]) }
  const {
    handleSubmit,
    setValue,
    reset,
    
  } = useForm<AvailabilityFormFields>(formOptions);
 
  const [absValue, setAbsValue] = useState<string>()
  // const [defaultDate, setDefaultDate] = useState <Date | null>(new Date());
  const [week, setWeek] = useState<any>()
  const [workType, setWorkType] = useState<number>()
  const [availablitytype, setAvailablitytype] = useState<number>()
  const [remoteType, setRemoteType] = useState<number>()
  const [date, setDate] = useState<any>()
  const [datePick, setDatePick] = useState <Date | null> ()
  const [errors, setErros] = useState<{ workType?: string, availablitytype?: string, remoteType?: string}>({ workType: "", availablitytype: "", remoteType: "" })
  const [jobsearch, setJobsearch] = useState <any> ()
  
  let datevalue = defaultValues.availability && defaultValues.availability.availabilityId === 2 && defaultValues.availability.date ? defaultValues.availability.date : 0
  let newDate = datevalue!==0 ?new Date(datevalue) : 0

  const handleChange = (e: any, name: string) => {

    if(name === 'jobSearchCriteria'){
      setValue('jobSearchCriteria', e.value)
      setJobsearch(e.value)
    }

    if ( name === 'workType'){
      delete errors.workType
      setValue('workType', e.value)
      setWorkType(e.value)
    }
    if ( name === 'contractType'){
      delete errors.remoteType
      setValue('contractType', e.value)
      setRemoteType(e.value)
    }
    if ( name === 'availabilityId'){
      setDatePick(null)
      setDate('')
      setAvailablitytype(e.value); 
      setWeek(''); 
      setAbsValue('')
      setValue('availabilityId', e.value)    
      delete errors.availablitytype
    }

    if (name === 'date') {
      delete errors.availablitytype
      let newValue = Utils.getMilliSecUTC(e.value)
      setDate(newValue)
      setWeek('')
      setDatePick(new Date(newValue))
      newDate = 0
      setValue('date', newValue)
      delete errors.availablitytype
    }

    if (name === 'weeks') {
      setWeek(e.target.value)
      setAbsValue(e.target.value ? Math.abs(e.target.value).toString() : '')
      setValue('weeks', e.target.value)
      if (e.target.value > 99) {
        errors.availablitytype='Provide a valid number'
      } else {
        delete errors.availablitytype
      }
    } 

    setErros({...errors})

  }
  

  useEffect(() => {
    if(defaultValues) {
      reset(defaultValues);  
      setWorkType(defaultValues.workType)
      setRemoteType(defaultValues.contractType)
      setAvailablitytype(defaultValues.availability && defaultValues.availability.availabilityId)
      setJobsearch(defaultValues.jobSearchCriteria)      
      if ( defaultValues.availability && defaultValues.availability.availabilityId === 2){
        // let newDate = new Date(defaultValues.availability.date ? defaultValues.availability.date : 0)
        // setDefaultDate(newDate)
        setValue('date', date)
      }
      if ( defaultValues.availability && defaultValues.availability.availabilityId === 3){
        setValue('weeks', defaultValues.availability.date ? defaultValues.availability.date : null)
        setWeek(defaultValues.availability.date ? defaultValues.availability.date : null) 
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmitForm = (data: any) => {
    
    let hasError: boolean = false
    if(!workType){
      errors.workType='Select atleast one option'
      hasError=true
    }

    if(!remoteType){
      errors.remoteType='Select atleast one option'
      hasError=true
    }

    if(!availablitytype){
      errors.availablitytype='Select atleast one option'
      hasError=true
    }

    if (availablitytype === 2 && !date) {
      errors.availablitytype='Select date'
      hasError = true
    }
    if (availablitytype === 3 && !week) {
      errors.availablitytype='Select weeks'
      hasError = true
    }
    if (availablitytype === 3 && (week > 99 || week < 0)) {
      errors.availablitytype='Provide a valid number'
      hasError = true
    }
    

    if (!hasError) {

      // data.availability = {
      //   availabilityId: availablitytype,
      //   date: date ? date : 0
      // }
      data.availability =  {
        availabilityId: availablitytype,
        date: availablitytype === 2 ? date : 0,
        weeks: availablitytype === 3 ? week : 0,
        lastUpdateDate: new Date().getTime()
      }

      

      delete data.availabilityId
      delete data.weeks
      delete data.date
    
      OnSubmit(data)
      
    }
    
    setErros({...errors})
    
    if(data){
      window.scrollTo(0, 0);
      mixpanelData('New MWP - Availablity updated', {
        'distinct_id': profileMetadata.email,
        'Candidate email':profileMetadata.email,
        'Work type': data && Utils.checkWorkType(data.workType),
        'Contract type': data && Utils.checkContractType(data.contractType),
        'Availability': data && Utils.checkAvailability(data.availability),
        'JobSearch criteria' : data && data.jobSearchCriteria && Utils.checkJobSearch(data.jobSearchCriteria),
        'Candidate loginid': loginId
      })
    }
    if(data.jobSearchCriteria === undefined){
      delete data.jobSearchCriteria
    }
  }
  
  return (
    <form>
      <Headline4>Availability</Headline4>
      <FromHead>How do you want to work with global companies ?*</FromHead>
      <div className="form-group mb-40">
        <RadioGroup data={CONSTANTS.WorkType}
          layout="horizontal"
          handleChange={(e: any) => handleChange(e, 'workType')}
          checked={workType}
        />
        <Error>{errors?.workType}</Error>
      </div>
      <FromHead>How soon can you start with us?*</FromHead>
      <div className="form-group">
        <RadioButton name="availabilityId" label="Immediately, I’m ready to join any time" value={1} handleChange={(e: any) => handleChange(e, 'availabilityId')} checked={availablitytype === 1}/>
      </div>
      <div className="form-group">
        <div className={classnames(Styles.experienceWrap, Styles.experienceWrapMulti)}>
          <RadioButton name="availabilityId" label="I’m getting relieved from my current job by" value={2} handleChange={(e: any) => handleChange(e, 'availabilityId')}  checked={availablitytype === 2} />&nbsp;
          <div className={Styles.experienceDate}><Datepicker  defaultShow={false} min={new Date()} value={datePick} defaultValue={newDate} disabled={availablitytype === 2 ? false : true} onChange={(e: any) => handleChange(e, 'date')} /></div>&nbsp;
          
        </div>
      </div>
      <div className="form-group">      
        <div className={Styles.experienceWrap}>
          <RadioButton name="availabilityId" label="In" value={3} handleChange={(e: any) => handleChange(e, 'availabilityId')}  checked={availablitytype === 3}/>
          
          <Field
            type='number'
            id="weeks"
            name="weeks"
            defaultValue={defaultValues.availability && defaultValues.availability.availabilityId === 3 ? defaultValues.availability.date : ''}
            value={absValue}
            placeholder=""
            autoComplete='off'
            size="small"
            disabled={availablitytype === 3 ? false : true}
            onChange={(e: any) => handleChange(e, 'weeks')}
          /> weeks after I get the offer
        </div>
        </div>
        {/* <div className="form-group">
        <RadioButton name="availabilityId" label="Unknown" value={4} handleChange={(e: any) => handleChange(e, 'availabilityId')} checked={availablitytype === 4}/>
      </div> */}
      <div className="form-group mb-40">
        <RadioButton name="availabilityId" label="Unavailable for Jobs" value={4} handleChange={(e: any) => handleChange(e, 'availabilityId')} checked={availablitytype === 5}/>
      </div>
        <Error>{errors?.availablitytype}</Error>
      
     
      <FromHead>Are you interested in full time remote work ?*</FromHead>

      <div className="form-group">
        <RadioGroup data={CONSTANTS.RemoteType}
          layout="vertical"
          handleChange={(e: any) => handleChange(e, 'contractType')}
          checked={remoteType}
        />
        <Error>{errors?.remoteType}</Error>
      </div>
      <FromHead>Where are you in your job search?</FromHead>
     
      
      <div className="form-group">
      <RadioGroup data={CONSTANTS.jobSearchList}
          layout="vertical"
          handleChange={(e: any) => handleChange(e, 'jobSearchCriteria')}
          checked={jobsearch}
        />
      </div>

      <div className={Styles.formAction}>
        <Button onClick={handleSubmit(onSubmitForm)} variant="primary">Save</Button>
      </div>
    </form>
  );
}

export default Avilability;